module.exports = __webpack_public_path__ + "img/jhsju-icon.e1bdda6c.png";